// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.change-address-dialog .edit-address {\n  text-align: right;\n}\n.change-address-dialog .el-cascader {\n  width: 100%;\n}\n.change-address-dialog .el-dialog__body {\n  padding: 30px 30px 30px 20px;\n}\n", ""]);
// Exports
module.exports = exports;
